import classes from "./AuthPopupPasswordCheck.module.scss";
import MarkOkIcon from "components/icons/Components/MarkOkIcon";

interface IProps {
  minLength: number;
  maxLength: number;
  passLengthIsOk: boolean;
  passSymbolsIsOk: boolean;
}

export const AuthPopupPasswordCheck = ({ minLength, maxLength, passLengthIsOk, passSymbolsIsOk }: IProps) => {
  return (
    <div>
      <div className={classes.Block}>
        <MarkOkIcon color={passLengthIsOk ? "green" : "#FF536D"}/>
        <span>{minLength} to {maxLength} characters</span>
      </div>

      <div className={classes.Block}>
        <MarkOkIcon color={passSymbolsIsOk ? "green" : "#FF536D"}/>
        <span>Upper case and lower case letters, numbers</span>
      </div>
    </div>
  );
};
